import API from "shared/services/Api";
import { IConductTerm } from "shared/types/ConductTerm";

export const sendConductTerm = async (data: IConductTerm, userId: string) =>
  API.post(`oc/referrals/conduct-term?id=${userId}`, data);
